import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const CheckIn = () => {
  const { search } = useLocation();
  const key = new URLSearchParams(search).get('key');
  const history = useHistory();

  useEffect(() => {
    history.push(`/main?key=${key}`);
  }, [history, key]);

  return null;
};

export default CheckIn;
